import { Injectable } from '@angular/core';

import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';

import { WorldCupHubService } from './world-cup-hub.service';

@Injectable({ providedIn: 'root' })
export class WorldCupHubRouteGuard {
    constructor(
        private worldCupHubService: WorldCupHubService,
        private redirectHelperService: RedirectHelperService,
    ) {}

    canActivate(): boolean {
        if (this.worldCupHubService.cultureUrlData) {
            return true;
        } else {
            this.redirectHelperService.goHome();

            return false;
        }
    }
}
